"use client";

import { useState, type ReactNode } from "react";
import { ChevronDownIcon } from "@/components/feature-icons";

const FAQS: { q: string; a: ReactNode }[] = [
  {
    q: "When is support available?",
    a: "Support is available 24 hours a day, 7 days a week through live chat and email.",
  },
  {
    q: "How quickly will my support request be resolved?",
    a: "All support requests are resolved within 4 hours.",
  },
  {
    q: "Can I request telephone support?",
    a: "Yes. Telephone support is available on request. Select telephone as your preferred contact method and provide the best number to reach you.",
  },
  {
    q: "Should I send my API secret key when asking for technical support?",
    a: "No. Never send passwords or KleipData API secret keys in a support request.",
  },
  {
    q: "Where can I manage my API access?",
    a: (
      <>
        Authorised customers can manage API access through{" "}
        <a
          href="https://portal.kleipdata.co.uk"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-brand-electric hover:underline"
        >
          portal.kleipdata.co.uk
        </a>
        .
      </>
    ),
  },
];

export function SupportFaq() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <ul className="mx-auto max-w-3xl divide-y divide-outline-variant/60 border-y border-outline-variant/60">
      {FAQS.map((item, i) => {
        const isOpen = open === i;
        return (
          <li key={item.q}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-electric"
            >
              <span className="text-base font-semibold text-brand-navy">
                {item.q}
              </span>
              <ChevronDownIcon
                className={`h-5 w-5 shrink-0 text-brand-electric transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            <div
              className={`grid transition-[grid-template-rows] duration-200 ease-out ${
                isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
              }`}
            >
              <div className="overflow-hidden">
                <p className="pb-5 pr-9 text-sm leading-relaxed text-on-surface-variant">
                  {item.a}
                </p>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
